import { render, staticRenderFns } from "./addAndEditForm.vue?vue&type=template&id=70e4bb73&"
import script from "./addAndEditForm.vue?vue&type=script&lang=ts&"
export * from "./addAndEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./addAndEditForm.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports